/* eslint-disable */
/* eslint-disable prefer-template */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { setTransportOrdersSort, setVehiclesSort } from '../actions';
import { selectTransportOrderFilter } from '../selectors';
import { Dropdown } from '../../../components/Dropdown';
import styles from './TransportOrderSortSelector.module.css';

const STATE = {
  selected: null,
};

let TRANSPORT_ORDER_SORT_OPTIONS = [
  'address_from_postcode_asc',
  'address_from_postcode_desc',

  'address_to_postcode_asc',
  'address_to_postcode_desc',

  'id_asc',
  'id_desc',
];

/* eslint-disable react/prefer-stateless-function */
class TransportOrderSortSelectorComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  static getDerivedStateFromProps(props, state) {}

  handleChange = option => {
    console.log(this.state.selected);
    let sortType;
    let order = 'desc';
    this.setState({ selected: option?.value, currentSelectedValue: option?.value });
    switch (option.value) {
      case 'address_from_postcode_asc': {
        sortType = 'addressFrom';
        order = 'asc';
        break;
      }
      case 'address_from_postcode_desc': {
        sortType = 'addressFrom';
        order = 'desc';
        break;
      }
      case 'address_to_postcode_asc': {
        sortType = 'addressTo';
        order = 'asc';
        break;
      }
      case 'address_to_postcode_desc': {
        sortType = 'addressTo';
        order = 'desc';
        break;
      }

      case 'id_asc': {
        sortType = 'id';
        order = 'asc';
        break;
      }
      case 'id_desc': {
        sortType = 'id';
        order = 'desc';
        break;
      }
    }
    this.props.setSort(sortType, order);
  };

  get options() {
    return TRANSPORT_ORDER_SORT_OPTIONS?.map(o => {
      const lbl = `transport_order.sort.${o}`;
      return { label: `${this.lblStr(lbl)}`, value: o };
    });
  }

  render() {
    let selectedLabel = this.options.find(opt => opt.value == this.state.currentSelectedValue)?.label;

    return (
      <div className={styles.container}>
        <Dropdown
          placeholder={this.lblStr(`transport_order.sort.by`)}
          options={this.options}
          value={selectedLabel}
          onChange={this.handleChange}
          className={styles.dropdown}
        />
      </div>
    );
  }
}

TransportOrderSortSelectorComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectTransportOrderFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setSort(type, order) {
      dispatch(setTransportOrdersSort(type, order));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderSortSelector = compose(withConnect, withRouter, injectIntl)(TransportOrderSortSelectorComp);
